export const OauthPopupLoginAndRedirect = (url: string, name: string): void => {
  const POLLING_INTERVAL = 1000;

  let windowObjectReference: Window | null = null;
  let previousUrl: string | null = null;
  const getWindowOptions = (width: number, height: number): string => {
    return `width=${width},height=${height},toolbar=0,location=0,menubar=0,status=0`;
  };
  const windowOpts: string = getWindowOptions(900, 500);
  const openSignInWindow = (url: string, name: string): void => {
    if (windowObjectReference === null || windowObjectReference.closed) {
      windowObjectReference = window.open(url, name, windowOpts);
    } else if (previousUrl !== url) {
      windowObjectReference = window.open(url, name, windowOpts);
      if (windowObjectReference) {
        windowObjectReference.focus();
      }
    } else {
      if (windowObjectReference) {
        windowObjectReference.focus();
      }
    }
    previousUrl = url;
    if (name === 'Zendesk') return;

    const timer = setInterval(() => {
      if (windowObjectReference?.closed) {
        clearInterval(timer);
        window.location.reload();
      }
    }, POLLING_INTERVAL);
  };

  openSignInWindow(url, name);
};
